import { GetBaseUrl } from '@/functions';
import { Configuration } from '@/generated/src/runtime';
import { SystemApi, CustomCalcApi } from '@/generated/src';

const apiConfig = new Configuration({
  basePath: GetBaseUrl(),
  credentials: 'include', // withCredentialsと同等
});

export const generateAPI = () => {
  const systemApi = new SystemApi(apiConfig);
  const customCalcApi = new CustomCalcApi(apiConfig);
  return { systemApi, customCalcApi };
};
